import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { Rectificatif } from '../models/Rectificatif';
import { RectificatifService } from './rectificatif/rectificatif.service';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { TypeAvisEnum } from 'src/app/models/enums/type-avis.enum';
import { TypeMarcheEnum } from 'src/app/models/enums/type-marche.enum';
import { TypeOrganismeEnum } from 'src/app/models/enums/type-organisme.enum';
import { MontantMarcheEnum } from 'src/app/models/enums/montant-marche.enum';
import { Annonce } from '../../../common/models/annonce';
import { LogService } from '../../../../shared/services/log.service';
import { CommonService } from '../../../common/services/common/common.service';
import { FnsimpleService } from '../../common/services/fnsimple.service';
import { FNSimple } from '../../common/models/FNSimple';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class FormfnSimpleRectificatifExtractorService {

  private LOG: LogService = new LogService(FormfnSimpleRectificatifExtractorService);

  constructor(private formExtractorService: FormExtractorService,
    private rectificatifService: RectificatifService,
    private commonService: CommonService, private fnsimpleService: FnsimpleService,
    private avisDataTransferService: AvisDataTransferService) { }

  public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
    const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

    const rectificatif = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.rectificatifFromFNSimple;

    if (stepId === 1) {
      rectificatif.avisInitial =
        this.rectificatifService.avisInitialService.getAvisInitial(controls);
    }
    if (stepId === 3 || stepId === 4) {
    rectificatif.natureMarche =
      this.rectificatifService.descriptionService.getDescription(
        controls,
        this.formExtractorService,
        stepId
      );
    }
    if (stepId === 5) {
    let index = 0;

    const infosRectifs = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_TypeAnn_'],'SepSep_Rectificatif_index_');
    for(const infoRectif of Array.from(infosRectifs)) {
      rectificatif.infosRectif[index] =  controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_index_'+ (index + 1) +'_SepAtt_infosRectif');
      index ++;
    }
    }


    const fnSimple: FNSimple = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple;
		if (stepId === 2) {
      fnSimple.organisme = this.fnsimpleService.organismeService.getOrganisme(controls);
    }
		fnSimple.initialFromFNSimple = null;
		fnSimple.attribution = null;
		fnSimple.rectificatifFromFNSimple = rectificatif;
		fnSimple.annulationFromFNSimple = null;

		const annonce: Annonce = new Annonce();
    annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
		annonce.ann.divers = null;
		annonce.ann.mapa = null;
		annonce.ann.fnSimple = fnSimple;
		annonce.ann.formAD = null;
		annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
		annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
		annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

		annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		
    let avis: Avis = new Avis();

    avis.jsonSaisieFormulaire = annonce;
    avis.formulaire.code = FormsEnum[FormsEnum.SIMP_RE];
    avis.critere.typeAvis.code=TypeAvisEnum.C4_4;
    return avis;
  }
}
